export default __webpack_public_path__ + "static/media/Defence.caef0194.svg";